import { useMenu } from "@/components/shell/Menu";

import { groupMenuItems } from "./groupMenu";
import type { UseGroups } from "./useGroups";

/**
 * The note's confusion groups, as chips (日本-601) — in 単語's dock and in a group's.
 *
 * Shaped like `TagChips` beside it on purpose, and deliberately **not** tags: a group is Postgres
 * state, so a chip here writes nothing to the collection. `+ グループ` opens the same submenu as
 * the row menu and 復習's `Card ⋯`, so the three ways in cannot disagree about what a tick means.
 */
export function GroupChips({ noteId, groups }: { noteId: number; groups: UseGroups }) {
  const menu = useMenu();
  const mine = new Set(groups.membership.get(noteId) ?? []);
  const held = groups.groups.filter((g) => mine.has(g.id));

  return (
    <div className="flex flex-wrap items-center gap-1.5 pt-1" data-check="dock.groups">
      <span className="mr-1 text-meta text-ink-4">グループ</span>
      {held.map((group) => (
        <span
          key={group.id}
          className="inline-flex items-center gap-1.5 rounded-[var(--r-4)] border border-line-strong px-[9px] py-[2px] text-[14px]/[1.5] text-ink-2"
        >
          {group.name}
          <button
            type="button"
            onClick={() => groups.actions.remove(group, [noteId])}
            aria-label={`グループ「${group.name}」から外す`}
            className="text-[14px] text-ink-3 hover:text-accent-text"
          >
            ×
          </button>
        </span>
      ))}
      <button
        type="button"
        data-check="dock.groups.add"
        onClick={(event) =>
          menu.openFrom(
            event.currentTarget,
            groupMenuItems(groups.groups, [noteId], groups.membership, groups.actions),
            `dock.groups.${noteId}`,
          )
        }
        className="rounded-[var(--r-4)] border-[1.5px] border-dashed border-line-strong px-[9px] py-[2px] text-[14px]/[1.5] text-ink-4 hover:text-accent"
      >
        + グループ
      </button>
    </div>
  );
}
